import api from '@/core/api/api';

/**
 * Notification Service - Centralized notification system
 * Uses new consolidated notification endpoints
 */
const notificationService = {
  
  /**
   * Get dashboard metrics from notification counts (FAST)
   * Replaces expensive getDashboardData calls
   */
  getDashboardAnalytics: async (userId, userType, userName) => {
    const response = await api.get('/analytics/dashboard', {
      params: {
        user_id: userId,
        user_type: userType,
        user_name: userName
      }
    });
    return response.data;
  },

  /**
   * Get paginated notifications for user
   * NEW: Uses centralized notification service
   */
  getNotifications: async (userId, userType, options = {}) => {
    const { limit = 20, status = 'unread' } = options;
    
    const params = {
      status,
      user_type: userType,
      limit
    };
    
    const response = await api.get(`/notifications/user/${userId}`, { params });
    return response.data;
  },

  /**
   * Get unread notification counts by type
   * NEW: Uses centralized notification service
   */
  getUnreadCounts: async (userId, userType) => {
    const response = await api.get(`/notifications/user/${userId}/unread-counts`, {
      params: { user_type: userType }
    });
    return response.data;
  },

  /**
   * Mark specific notification as read
   * NEW: Uses centralized notification service
   */
  markAsRead: async (userId, notificationId) => {
    const response = await api.put(`/notifications/read/${notificationId}`, {
      user_id: userId
    });
    return response.data;
  },

  /**
   * Mark all notifications as read
   * NEW: Uses centralized notification service
   */
  markAllAsRead: async (userId, userType) => {
    const response = await api.put(`/notifications/user/${userId}/read-all`, {
      user_type: userType
    });
    return response.data;
  }
};

export default notificationService; 